import { sendToMixpanel, getUserProps } from '../mixpanel';
import getEntryPoint from '../get-entry-point';
import type { DepthTierLabel } from '../../utils/depth-tier';
import type { SearchResultsBaseProperties } from './search-results-base-properties';

export interface TapAgentCardProps {
  baseProperties?: SearchResultsBaseProperties;
  depthTier?: DepthTierLabel;
  suggestionPosition: number;
  agentRating: boolean;
  reviewCount?: number;
  starRating?: number;
}

/**
 * Track Tap Agent Card event
 * Fires once when an agent card on the search results is clicked
 */
function trackTapAgentCard({
  baseProperties = {},
  depthTier,
  suggestionPosition,
  agentRating,
  reviewCount,
  starRating,
}: TapAgentCardProps): void {
  const entryPoint = getEntryPoint();

  sendToMixpanel('Tap Agent Card', {
    siteSection: 'Agents',
    ...(entryPoint && { entryPoint }),
    ...baseProperties,
    ...getUserProps(),
    ...(depthTier && { 'Depth Tier': depthTier }),
    suggestionPosition,
    agentRating,
    ...(typeof reviewCount === 'number' && { reviewCount }),
    ...(typeof starRating === 'number' && { starRating }),
  });
}

export default trackTapAgentCard;
